const messages = {
    menuTitle: 'Produkty',
    productPageTitle: 'Produkty / Produkt',
    pages: {
        main: {
            sections: {
                title: 'Produkty',
                filters: {
                    hideExpanded: 'Ukryj rozpisane',
                    searchPlaceholder: 'Szukaj'
                },
                table: {
                    columns: {
                        name: 'Nazwa',
                        hasComponents: 'Czy rozpisany?',
                        actions: 'Akcje',
                        edit: 'Edytuj'
                    }
                }
            },
            errors: {
                fetchList: 'Pobranie listy produktów nie powiodło się.'
            }
        },
        edit: {
            sections: {
                title: 'Produkty / {name}',
                backToList: 'Powrót do listy',
                leaveConfirmation: {
                    title: 'Opuścić stronę?',
                    message: 'Produkt nie został zapisany. Czy chcesz opuścić stronę?'
                },
                tabs: {
                    features: 'Cechy produktu',
                    components: 'Komponent'
                },
                features: {
                    signaturesDivision: 'Podział wnętrz na składki',
                    requiresDieCutter: 'Wymaga wykrojnika',
                    dieCutterPrefix: 'Prefiks wykrojnika',
                    dieCutterProperty: 'Cecha sklepowa dla wykrojnika'
                },
                actions: {
                    save: 'Zapisz'
                },
                components: {
                    title: 'Komponenty produktu',
                    noComponents: 'Produkt nie posiada przypisanych komponentów.',
                    assignComponent: 'Wybierz komponent do dodania',
                    selectComponent: 'Wybierz komponent',
                    configureComponent: 'Konfiguruj komponent',
                    parameters: 'Parametry',
                    processes: 'Procesy',
                    addParameters: 'Dodaj parametry',
                    addProcesses: 'Dodaj procesy',
                    selectParameter: 'Wybierz parametr',
                    selectProcess: 'Wybierz proces',
                    noParameters: 'Brak przypisanych cech produkcyjnych.',
                    noProcesses: 'Brak przypisanych procesów produkcyjnych.',
                    discardChanges: 'Czy na pewno chcesz porzucić niezapisane zmiany?',
                    add: 'Dodaj',
                    edit: 'Edytuj',
                    remove: 'Usuń komponent',
                    removeConfirmTitle: 'Usunąć komponent z produktu?',
                    removeConfirmContent: 'Czy na pewno chcesz usunąć ten komponent z produktu?',
                    cancel: 'Anuluj',
                    save: 'Zapisz',
                    no: 'Nie'
                },
                notifications: {
                    saveChangesFirst: 'Aby przejść do edycji cech sklepowych należy zapisać zmiany na konfiguracji produktu.',
                    createSuccess: 'Produkt został utworzony.',
                    updateSuccess: 'Produkt został zaktualizowany.',
                    deleteSuccess: 'Produkt został usunięty.'
                }
            },
            errors: {
                fetchProduct: 'Błąd podczas pobierania produktu.',
                fetchProductionProperties: 'Błąd podczas pobierania cech produkcyjnych.',
                fetchComponents: 'Błąd podczas pobierania komponentów produktu.',
                fetchProcesses: 'Błąd podczas pobierania procesów produkcyjnych.',
                fetchProperties: 'Błąd podczas pobierania cech produktu.',
                fetchAllProperties: 'Błąd podczas pobierania wszystkich cech produktu.',
                update: 'Błąd podczas aktualizacji produktu.'
            }
        }
    }
}

export default {
    messages: messages,
    locale: 'pl'
}
